'use client'
import React from 'react'

export const SettingsContext = React.createContext(null)
